import { useEffect } from "react";

import NavBarCustom from "../../components/NavBarCustom/NavBarCustom";
import { ScrollTop } from "../../components/ScrollTop/ScrollTop";
import Contact from "../../containers/Contact/Contact";
import Footer from "../../containers/Footer/Footer";

import "../../App.css";
import "./ContactPage.css";

const ContactPage = (props) => {
	useEffect(() => {
		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="contact-container navbar-correction">
			<div id="back-to-top-anchor"></div>

			<NavBarCustom actualRef={"contact"} />
			<Contact title={false} />
			<Footer />

			<ScrollTop props={props} />
		</div>
	);
};

export default ContactPage;
